import { CFormLabel } from '@coreui/react-pro'

export const FormLabel = ({ ...props }) => {
  return <CFormLabel>{props.name}</CFormLabel>
}
